const LOGO_URL = '/brand/twp-logo.png';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';

const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

// Branded loading state shown while auth/profile data is still resolving —
// same visual language as the static splash baked into index.html, so
// there's no jarring swap once React takes over from the pre-mount HTML.
export default function SplashScreen({ label = 'Loading your workspace…' }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: PAPER,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: '18px', fontFamily: FONT_SANS, zIndex: 9999,
    }}>
      <img src={LOGO_URL} alt="TWP" style={{ width: '64px', height: 'auto', filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.12))' }} />
      <div style={{ fontFamily: FONT_DISPLAY, fontSize: '19px', fontWeight: 600, color: INK, letterSpacing: 0 }}>
        The Window Place LLC Hub
      </div>
      <div style={{
        width: '28px', height: '28px', borderRadius: '50%',
        border: `3px solid ${WALNUT}22`, borderTopColor: WALNUT,
        animation: 'twp-splash-spin 0.8s linear infinite',
      }} />
      <div style={{ fontSize: '12.5px', color: STONE, fontWeight: 500 }}>{label}</div>
      <style>{`@keyframes twp-splash-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
